<template>
  <div>
    <v-toolbar tile flat elevation="1">
      <v-btn
        v-if="contest"
        :to="{ name: 'ContestShow', params: { slug: this.contest.slug } }"
        class="no-active"
        icon
      >
        <v-icon>$vuetify.icons.arrow_left</v-icon>
      </v-btn>
      <v-toolbar-title>Добавить книгу</v-toolbar-title>
    </v-toolbar>
    <v-container v-if="!loadPage" class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" class="py-0">
          <contest-details></contest-details>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-card class="elevation-0 mt-4">
            <v-form v-model="valid" ref="form">
              <v-row>
                <v-col cols="12">
                  <div v-if="mybooks.length > 0">
                    <v-select
                      v-model="book_id"
                      :items="mybooks"
                      item-text="title"
                      item-value="id"
                      label="Выберите книгу"
                      :rules="requiredRules"
                    ></v-select>
                    <v-btn
                      dark
                      color="primary"
                      :loading="addLoader"
                      @click="submit"
                      >Добавить</v-btn
                    >
                  </div>
                  <div v-else class="text-center">У вас нет книг!</div>
                </v-col>
              </v-row>
            </v-form>
          </v-card>

          <v-card
            class="elevation-0 mt-4"
            v-if="current_user_books && current_user_books.length > 0"
          >
            <v-list>
              <v-subheader>Участвующие книги</v-subheader>
              <v-list-item v-for="book in current_user_books" :key="book.title">
                <v-list-item-icon>
                  <v-icon class="mr-2">$vuetify.icons.book_open_variant</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-text="book.title"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    :loading="dellLoader"
                    icon
                    @click="deleteBookModal(book.id)"
                  >
                    <v-icon>$vuetify.icons.delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogDeleteBook" class="text-center" max-width="290">
        <v-card>
          <v-card-title class="headline justify-center"
            >Вы уверены?</v-card-title
          >

          <v-card-text class="text-center"
            >Что хотите снять произведение с участия в конкурсе.</v-card-text
          >

          <v-card-actions class="justify-space-around">
            <v-btn color="red darken-1" text @click="deleteBook">Да</v-btn>

            <v-btn color="green darken-1" text @click="dialogDeleteBook = false"
              >Нет</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ContestDetails from "./ContestDetails.vue";
export default {
  components: {
    ContestDetails,
  },
  data: () => ({
    slug: "",
    book_id: null,
    addLoader: false,
    dellLoader: false,
    dialogDeleteBook: false,
    delete_book_id: null,
    valid: true,
    title: "",
    body: "",
    completed: 0,
    requiredRules: [(v) => !!v || "Поле обязательно"],
    titleRules: [
      (v) => !!v || "Поле обязательно",
      (v) => v.length >= 3 || "Минимум 3 символа",
    ],
    bodyRules: [
      // v => !!v || 'Поле обязательно',
      (v) => !!v === v.length >= 10 || "Минимум 10 символов",
    ],
  }),
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    submit() {
      if (!this.validate()) return;

      let app = this;
      app.addLoader = true;
      this.$store
        .dispatch("contest/bookAdd", {
          book_id: app.book_id,
          contest_id: app.contest.id,
        })
        .then(() => {
          app.$router.push({
            name: "ContestShow",
            params: { slug: app.contest.slug },
          });
          app.addLoader = false;
        })
        .catch(() => {
          app.addLoader = false;
        });
    },
    deleteBook() {
      let app = this;
      app.dellLoader = true;
      app.dialogDeleteBook = false;
      this.$store
        .dispatch("contest/deleteBook", {
          book_id: app.delete_book_id,
          contest_id: app.contest.id,
        })
        .then(() => {
          app.dellLoader = false;
        })
        .catch(() => {
          app.dellLoader = false;
        });
      app.delete_book_id = null;
    },
    deleteBookModal(book_id) {
      // console.log(book_id);
      this.delete_book_id = book_id;
      this.dialogDeleteBook = true;
    },
    getContest() {
      var app = this;
      this.$store.dispatch("contest/getContestAdd", {
        slug: app.slug,
      });
    },
  },

  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      loadPage: "loadPage",
      mybooks: "contest/mybooks",
      current_user_books: "contest/current_user_books",
      contest: "contest/contest",
      loader: "loader",
    }),
  },
  created() {
    this.slug = this.$route.params.slug ? this.$route.params.slug : null;
    this.getContest();
  },
};
</script>
